var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "181",
        height: "136",
        viewBox: "0 0 181 136",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_1097_61414",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "181",
            height: "136",
          },
        },
        [
          _c("rect", {
            attrs: { width: "181", height: "136", fill: "#D9D9D9" },
          }),
        ]
      ),
      _c("g", { attrs: { mask: "url(#mask0_1097_61414)" } }, [
        _c("path", {
          attrs: {
            d: "M182.327 -16L0 -15.4178L0.673383 145L183 144.418L182.327 -16Z",
            fill: "#F15073",
          },
        }),
        _c("path", {
          attrs: {
            d: "M-1.34023 2.00054C50.0206 1.84083 91.8113 37.0786 91.9994 80.7127C92.1874 124.343 50.7014 159.84 -0.659284 159.999C-52.0214 160.159 -93.8113 124.921 -93.9994 81.291C-94.1874 37.6573 -52.7026 2.1603 -1.34023 2.00054Z",
            fill: "#F780A0",
          },
        }),
        _c("path", {
          attrs: {
            d: "M184.162 1.00051C235.247 0.849855 276.812 34.0804 276.999 75.2291C277.186 116.374 235.924 149.849 184.84 149.999C133.753 150.15 92.1877 116.919 92.0006 75.7744C91.8136 34.6261 133.075 1.15112 184.162 1.00051Z",
            fill: "#D4436A",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }